import { QueryKey, useQuery } from "react-query";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";
import { getPermitsType } from "../../../../queries/permitsTypes";

export default function usePermitType({ permitTypeId, active }: { permitTypeId: string | number; active?: boolean }) {
  const networkHeaders = useNetworkHeaders();
  const key = getPermitTypeQueryKey(permitTypeId, active);

  const permitTypeQuery = useQuery(key, getPermitsType(networkHeaders), {
    enabled: !!permitTypeId,
    queryFnParamsFilter: (key) => {
      return key.slice(1);
    },
  });
  return permitTypeQuery;
}

export function getPermitTypeQueryKey(permitTypeId: string | number | undefined, active?: boolean): QueryKey {
  return ["permits-types", permitTypeId?.toString(), active].filter((key) => key);
}
